module.exports = __webpack_public_path__ + "img/lobby_hosting_current_show.efc6760c.png";